import axiosClient from '../axiosClient';

const homeAPI = {
    async currentHomeSetting(phone) {
        const url = `/current_home_setting/current?`;
        const currentHomeRes = await axiosClient.get(url);
        const params = {
            fields: '["$all"]',
            phone: phone,
        };
        if (currentHomeRes) {
            const res = await axiosClient.get(`/home/${currentHomeRes?.results?.object?.current_home_setting_id}`, {
                params,
            });
            return res?.results?.object;
        }
        return;
    },
};

export default homeAPI;
